import React from "react";
import Background from "./Background";

const Welcome = ({ darkMode }) => {
  return (
    <section
      id="welcome"
      style={{
        position: "relative",
        width: "98vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Background */}
      <Background />

      {/* Content */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "gray",
          padding: "2rem",
          borderRadius: "10px",
          textAlign: "center",
          color: "#ffffff",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.5)",
        }}
      >
        <h1 style={{ fontSize: "2.5rem", marginBottom: "1rem", color: darkMode ? "#FFFFFF" : "#000000" }}>
          Welkom bij mijn portfolio
        </h1>
        <p style={{ fontSize: "1.2rem", marginBottom: "2rem" }}>
          Ik ben Joppe Dierckx, een gepassioneerde applicatieontwikkelaar en
          IT-enthousiast. Momenteel ben ik aan het einde van mijn studie, en met
          dit portfolio wil ik laten zien dat ik klaar ben om af te studeren.
          Hier kunt u meer over mij te weten komen, mijn vaardigheden ontdekken
          en een overzicht zien van alle projecten die ik succesvol heb
          gerealiseerd.
        </p>
        <div className="text-center mt-4">
          <div className="mt-3">
            <a
              href="https://github.com/JoppeDierckx"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary me-2"
            >
              Github
            </a>
            <a
              href="https://www.linkedin.com/in/joppe-dierckx-aa8776251/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
